import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { JsonProperty, JsonObject } from 'json2typescript';
import { Required, EmptyControl } from '@hvlng/framework-bff/core';
import { PerObjectModel } from '../../../../model/per-object-model';
import {CodeTextDiscriminatorModel} from "humanresources-common-shared";

@JsonObject('KovanHrPerOrganizationGeneralInfoModel')
export class PerOrganizationGeneralInfoModel extends HvlBaseModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @Required()
    @JsonProperty('count', Number, true)
    count: number = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionId', Number, true)
    perObjectDefinitionId: number = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionUuid', String, true)
    perObjectDefinitionUuid: string = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionText', String, true)
    perObjectDefinitionText: string = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionUnitCode', String, true)
    perObjectDefinitionUnitCode: string = null;

    @EmptyControl()
    @JsonProperty('companyId', Number, true)
    companyId: number = null;

    @EmptyControl()
    @JsonProperty('companyName', String, true)
    companyName: string = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionPId', Number, true)
    perObjectDefinitionPId: number = null;

    @EmptyControl()
    @JsonProperty('positionId', Number, true)
    positionId: number = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionPText', String, true)
    perObjectDefinitionPText: string = null;

    @EmptyControl()
    @JsonProperty('managerPerPeopleId', Number, true)
    managerPerPeopleId: number = null;

    @EmptyControl()
    @JsonProperty('objectNumber', String, true)
    objectNumber: string = null;

    @EmptyControl()
    @JsonProperty('employeeCount', Number, true)
    employeeCount: number = 0;

    @EmptyControl()
    @JsonProperty('employeeTotalCount', Number, true)
    employeeTotalCount: number = 0;

    @EmptyControl()
    @JsonProperty('objectStatusId', Number, true)
    objectStatusId: number = null;

    @EmptyControl()
    @JsonProperty('objectStatus', CodeTextDiscriminatorModel, true)
    objectStatus: CodeTextDiscriminatorModel = null;

    @EmptyControl()
    @JsonProperty('objectStatusText', String, true)
    objectStatusText: string = null;

    @EmptyControl()
    @JsonProperty('genCountryId', Number, true)
    genCountryId: number = null;

    @EmptyControl()
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @EmptyControl()
    @JsonProperty('name', String, true)
    name: string = null;

    @EmptyControl()
    @JsonProperty('surname', String, true)
    surname: string = null;

    @JsonProperty('perObjectModel', PerObjectModel, true)
    perObjectModel: PerObjectModel = null;
    @EmptyControl()
    @JsonProperty('versionIdName', String, true)
    versionIdName: string = null;

    @EmptyControl()
    @JsonProperty('versionId', Number, true)
    versionId: number = null;

    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    active: boolean = null;
    @EmptyControl()
    @JsonProperty('parentUnit', String, true)
    parentUnit: string = null;
}
